import Weather from "./components/Weather/Weather";

export default function App() {
  return (
    <>
      <Weather />
    </>
  );
}
